import { render } from "./StructureEdit.vue?vue&type=template&id=1a38ac9b&scoped=true"
import script from "./StructureEdit.vue?vue&type=script&lang=ts"
export * from "./StructureEdit.vue?vue&type=script&lang=ts"

import "./StructureEdit.vue?vue&type=style&index=0&id=1a38ac9b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1a38ac9b"

export default script